/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
declare let Box: {
  Preview: {
    new (): {
      show: (
        fileId: string,
        accessToken: string,
        options: ContentPreviewOpts
      ) => void;
      addListener: (event: string, callback: () => void) => void;
    };
  };
};

@Injectable({ providedIn: 'root' })
export class PdfPreviewService {
  private _renderingSubject = new Subject<void>();
  public renderingComplete$: Observable<void> =
    this._renderingSubject.asObservable();
  private _contentPreview: InstanceType<(typeof Box)['Preview']>;
  public isRendering = false;

  public showPreview(
    fileId: string,
    accessToken: string,
    options: ContentPreviewOpts
  ): void {
    this.isRendering = true;
    this._contentPreview = new Box.Preview();

    this._contentPreview.show(fileId, accessToken, options);

    this._contentPreview.addListener('load', () => {
      this.isRendering = false;
      this._renderingSubject.next();
    });
  }
}

export interface ContentPreviewOpts {
  container: string;
  showDownload: boolean;
  showAnnotations: boolean;
  logoUrl: string;
}
